import { Container, Box, Typography, Stack, Button, Card, CardContent, List, ListItem, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";

import ArrangementConfirmationInfoCard from "./ArrangementConfirmationInfoCard";
import ScrollToTop from "../../components/nav/ScrollToTop"

import { useArrangement } from "../../context/ArrangementProvider";
import { useAnalytics } from "../../context/AnalyticsProvider";
import { ANALYTICS_TAGS } from "../../constants/analyticsTags";

 /** 
  * Arrangement method component 
 */
function ArrangementMethod({ handleNext, handleBack }) {

  const location = useLocation();

  const { setHasArrangement, plan, savePlanData } = useArrangement();
  const { setTag } = useAnalytics();

  const saveNewArrangement = () => {
    setTag(ANALYTICS_TAGS.PPLAN_COMPLETE, { path: location.pathname });
    savePlanData(plan);
    setHasArrangement(true);
    handleNext();
  }

  return (
    <>
      <ScrollToTop />
      <Typography component='label' sx={{ fontWeight: "bold" }}>
        Your payment method
      </Typography>
      <Stack
        sx={{
          mt: 2,
        }}
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box sx={{ width: { xs: "100%", md: "70%" } }}>
          {/* Left column */}
          <Card
            sx={{ borderRadius: 0 }}
          >
            <CardContent>
              <CardContent>
                <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
                  Chase mobile app
                </Typography>

                <List component="ul" sx={{ listStyleType: 'disc', pl: 3 }}>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          Open the App and go to the <strong>‘Home’</strong> screen.
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          Tap on the <strong>‘Credit Card’</strong> tab
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          Tap on the <strong>‘Repay’</strong> option
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          This will highlight <strong>‘How would you like to repay?’</strong> Please select the monthly option, via <strong>‘manage’</strong>
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          This will show details around what account to repay from (<em>this can be edited to suit</em>), and the amount option. For this, select <strong>‘Edit’</strong> and then <strong>‘Fixed Amount’</strong>
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          Please enter the amount agreed as your monthly repayment plan amount and select <strong>‘Done’</strong>
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          Your repayment amount will be updated – please remember to review this monthly for the length of time the repayment plan has been agreed for.
                        </>
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                    <ListItemText
                      primary={
                        <>
                          After you have completed your plan remember to review the amount you'd like to pay going forward
                        </>
                      }
                    />
                  </ListItem>
                </List>
              </CardContent>
            </CardContent>
          </Card>
          {/* End of left column */}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "30%" } }}>
          {/* Right column */}
          <ArrangementConfirmationInfoCard />

          {/* Call To Action */}
          <Box sx={{ textAlign: "center", pt: 5, pb: 4 }}>
            <Container sx={{ pb: 2 }}>
              <Button
                onClick={saveNewArrangement}
                variant='contained'
                sx={{
                  textTransform: "none",
                  borderRadius: 0,
                  width: { xs: "15em", lg: "20em" },
                  backgroundColor: "primary.dark",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.light",
                    color: "primary.dark",
                  },
                }}
              >
                Confirm
              </Button>
            </Container>

            <Container sx={{ pb: 2 }}>
              <Button
                id='back-btn'
                onClick={handleBack}
                variant='outlined'
                sx={{
                  textTransform: "none",
                  borderRadius: 0,
                  border: "1px solid",
                  width: { xs: "15em", lg: "20em" },
                  backgroundColor: "#FFF",
                  color: "secondary.main",
                  "&:hover": {
                    backgroundColor: "secondary.main",
                    color: "#FFF",
                    border: "1px solid",
                  },
                }}
              >
                Back
              </Button>
            </Container>
          </Box>

          {/* End of right column */}
        </Box>
      </Stack>
    </>
  );
}

export default ArrangementMethod;
